import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { EntityIdObject } from "../../common/types";
import { serializeParams } from "../../common/utils/apiUtils";
import { VehicleBrand, VehicleModelBase } from "../contract/types";
import {
  AgentEnumeration,
  AgentEnumerationRequest,
  AgentEnumerationSearchRequest,
  AgentEnumerationSearchResult,
  EnumerationResponse,
  EnumerationsRequest,
} from "./types";

const GET_ENUMERATIONS = ApiRequestAdapter.create("/enumerations", HttpMethod.GET);

// Vehicle
const GET_VEHICLE_BRANDS = ApiRequestAdapter.create("/enumerations/vehicle-brands", HttpMethod.GET);
const GET_VEHICLE_BRAND = ApiRequestAdapter.create("/enumerations/vehicle-brands/{0}", HttpMethod.GET);
const GET_VEHICLE_MODELS = ApiRequestAdapter.create("/enumerations/vehicle-brands/{0}/vehicle-models", HttpMethod.GET);
const GET_VEHICLE_MODEL = ApiRequestAdapter.create("/enumerations/vehicle-models/{0}", HttpMethod.GET);

//Agent
const GET_AGENT_ENUMERATIONS = ApiRequestAdapter.create("/enumerations/agents", HttpMethod.POST);
const SEARCH_AGENT_ENUMERATIONS = ApiRequestAdapter.create("/enumerations/agents/search", HttpMethod.POST);

export const enumerationsApi = {
  getEnumerations: (request: EnumerationsRequest): AxiosPromise<EnumerationResponse> => {
    return apiService.get(GET_ENUMERATIONS.url, { params: request, paramsSerializer: serializeParams });
  },
  getVehicleBrands: (): AxiosPromise<VehicleBrand[]> => {
    return apiService.get(GET_VEHICLE_BRANDS.url);
  },
  getVehicleBrand: (request: EntityIdObject): AxiosPromise<VehicleBrand> => {
    return apiService.get(GET_VEHICLE_BRAND.getParametrizedUrl(request.id));
  },
  getVehicleModels: (request: EntityIdObject): AxiosPromise<VehicleModelBase[]> => {
    return apiService.get(GET_VEHICLE_MODELS.getParametrizedUrl(request.id));
  },
  getVehicleModel: (request: EntityIdObject): AxiosPromise<VehicleModelBase> => {
    return apiService.get(GET_VEHICLE_MODEL.getParametrizedUrl(request.id));
  },
  getAgentEnumerations: (request: AgentEnumerationRequest): AxiosPromise<AgentEnumeration[]> => {
    return apiService.post(GET_AGENT_ENUMERATIONS.url, request);
  },
  searchAgentEnumerations: (request: AgentEnumerationSearchRequest): AxiosPromise<AgentEnumerationSearchResult> => {
    return apiService.post(SEARCH_AGENT_ENUMERATIONS.url, request);
  },
};
